import apiClient from './api_client_requests';
import { getCookieByName } from './cookies';

export default (config) => {
    return async (payload) => {
        const appCookieKey = 'tokenCookie';
        const sharedCookieKey = 'AuthToken';

        const jwtFromCookie = getCookieByName(appCookieKey);
        const wholeTokenFromCookie = JSON.parse(getCookieByName(sharedCookieKey));

        let spatFromCookie = wholeTokenFromCookie.spat;

        let result = await apiClient(config).apiMethod({
            method: 'GetPlayerPromotions',
            headers: {
                'X-Auth-Token': jwtFromCookie,
                'X-Auth-Spat': spatFromCookie,
            },
            args: {
                ...payload,
            },
        });

        return result;
    };
};
